/* Lusty Owl redesign — reveals, count-ups, owl eyes, honest sale timer */
(function(){
  var S = window.loxSettings || {motion:true, owl:true};
  var reduce = (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) || S.motion === false;
  function countUp(root){
    root.querySelectorAll('[data-lox-count]').forEach(function(el){
      var to=+el.dataset.loxCount, from=+(el.dataset.loxFrom||0), t0=null;
      if(reduce||isNaN(to)){ return; }
      el.textContent=from;
      requestAnimationFrame(function st(ts){ if(!t0) t0=ts; var k=Math.min(1,(ts-t0)/1600), e=1-Math.pow(1-k,4);
        el.textContent=Math.round(from+(to-from)*e); if(k<1) requestAnimationFrame(st); });
    });
  }
  function init(scope){
    scope=scope||document;
    var els=scope.querySelectorAll('.lox-hero,.lox-band,.lox-row,.lox-pcard,.lox-ph,.lox-journey');
    if(!('IntersectionObserver' in window) || reduce){ els.forEach(function(e){e.classList.add('is-in');}); return; }
    var first=true;
    var io=new IntersectionObserver(function(ents){
      ents.forEach(function(en){
        var el=en.target;
        if(en.isIntersecting){ el.classList.remove('is-pre'); el.classList.add('is-in'); if(el.classList.contains('lox-band')||el.classList.contains('lox-ph')) countUp(el); io.unobserve(el); }
        else if(first && (el.classList.contains('lox-row')||el.classList.contains('lox-pcard'))) el.classList.add('is-pre');
      });
      first=false;
    },{threshold:.2});
    els.forEach(function(e){ io.observe(e); });
    scope.querySelectorAll('.lox-stat').forEach(function(s,i){ s.style.setProperty('--i',i); });
  }
  function owl(){
    var o=document.querySelector('.lox-owl'); if(!o||reduce||S.owl===false) return;
    var pupils=o.querySelectorAll('i');
    function look(x,y){ var r=o.getBoundingClientRect(), cx=r.left+r.width/2, cy=r.top+r.height/2, a=Math.atan2(y-cy,x-cx), d=Math.min(9,Math.hypot(x-cx,y-cy)/25);
      pupils.forEach(function(p){ p.style.transform='translate('+(Math.cos(a)*d).toFixed(1)+'px,'+(Math.sin(a)*d).toFixed(1)+'px)'; }); }
    var last=0, t=0;
    window.addEventListener('pointermove',function(e){ last=Date.now(); look(e.clientX,e.clientY); },{passive:true});
    setInterval(function(){ if(Date.now()-last<3000) return; t++; var r=o.getBoundingClientRect(); look(r.left+Math.cos(t)*200, r.top+Math.sin(t*1.3)*120); },1400);
  }
  function timers(){
    document.querySelectorAll('[data-lox-end]').forEach(function(box){
      var end=new Date(box.dataset.loxEnd), out=box.querySelector('b');
      function upd(){ var ms=end-Date.now(); if(isNaN(ms)||ms<=0){ box.hidden=true; return; }
        var d=Math.floor(ms/864e5), h=Math.floor(ms/36e5)%24, m=Math.floor(ms/6e4)%60, s=Math.floor(ms/1e3)%60;
        out.textContent=(d?d+'d ':'')+String(h).padStart(2,'0')+':'+String(m).padStart(2,'0')+':'+String(s).padStart(2,'0'); }
      upd(); setInterval(upd,1000);
    });
  }
  function satc(){
    var bar=document.querySelector('[data-lox-satc]'); if(!bar) return;
    var main=document.querySelector('product-form form button[name="add"], form[action*="/cart/add"] button[type="submit"]');
    if(!main){ bar.remove(); return; }
    bar.querySelector('[data-lox-satc-btn]').addEventListener('click',function(){ main.click(); });
    if('IntersectionObserver' in window){ new IntersectionObserver(function(e){ bar.hidden = e[0].isIntersecting || e[0].boundingClientRect.top > 0; }).observe(main); }
  }
  function tabbar(){
    var b=document.querySelector('[data-lox-menu]'); if(!b) return;
    b.addEventListener('click',function(){ var t=document.querySelector('header-drawer summary, .header__icon--menu'); if(t){ t.click(); window.scrollTo({top:0,behavior:'smooth'}); } });
  }
  function drawerAssure(){
    function add(){ var f=document.querySelector('.cart-drawer__footer'); if(f && !f.querySelector('.lox-drawer-assure')){ var d=document.createElement('div'); d.className='lox-drawer-assure'; d.innerHTML='<span><b>\u2713 Free worldwide shipping</b> in plain packaging</span><span>\u2713 A business name on your statement, never the products</span>'; f.appendChild(d);} }
    add(); var cd=document.querySelector('cart-drawer'); if(cd && 'MutationObserver' in window){ new MutationObserver(add).observe(cd,{childList:true,subtree:true}); }
  }
  function start(){ init(); owl(); timers(); satc(); tabbar(); drawerAssure(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start); else start();
  document.addEventListener('shopify:section:load',function(e){ init(e.target); timers(); });
})();
